import { defineMessages } from 'react-intl';

export const messages: {
	leadLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	leadLabel: {
		id: 'search-graph-lead.lead-label',
		defaultMessage: 'Lead',
		description: 'Lead noun type label for Salesforce Lead search results',
	},
});
